module.exports = "<button mat-stroked-button class=\"pnd-ZoomIn\">\n  <mat-icon>add</mat-icon>\n</button>\n"